import * as qs from "qs";
import {useStore} from "vuex";
import {computed} from "vue";

export default function(){
  const store = useStore()
  const rawQuery = location.search.split(/[?&]/).filter(q => {return q !== "" && q !== "gender=woman" && q !== "gender=man"}).filter(q => {return !q.substring(0,5).match("form")}).filter(q => {return !q.substring(0,7).match("userId")})

  const rawData = computed(() => {
    return store.state.moduleA.steps;
  })

  function reArrangeOrder(){
    let list1 = [],
        list2 = [],
        list3 = [],
        list4 = [],
        list5 = [],
        list6 = [],
        list7 = [],
        list8 = [],
        list9 = [],
        list10 = [];

    rawQuery.forEach(item => {
      if (item.match("base")){list1.push(item)}
      else if (item.match("shape")){list2.push(item)}
      else if (item.match("texture")){list3.push(item)}
      else if (item.match("surface")){list4.push(item)}
      else if (item.match("width")){list5.push(item)}
      else if (item.match("milgrain")){list6.push(item)}
      else if (item.match("outsideDia")){list7.push(item)}
      else if (item.match("insideDia")){list8.push(item)}
      else if (item.match("ringText")){list9.push(item)}
      else if (item.match("ringSize")){list10.push(item)}
    })

    return [].concat(list1,list2,list3,list4,list5,list6,list7,list8,list9,list10)
  }

  function extractQueryValues(){
 
    let container = []
    const query = reArrangeOrder()
    if (query.length){
      query.forEach((q,i) => {
        const prop = q.split("=")[0]
        const val = q.split("=")[1]
        /* apply different function on required steps between 1 ~ 6 */
        if (i+1 < 6){
          rawData.value[i]["step"+(i+1)].forEach(element => {
            if (element.val === val) {
              container.push(element)
            }
          })
        }
        else if (i+1 > 5) {
          if (prop === "milgrain") {
            rawData.value[5]["step" + (5 + 1)].forEach(element => {
              if (element.val === val) {
                container.push(element)
              }
            })
          } else if (prop === "outsideDia"){
            rawData.value[6]["step"+(6+1)].forEach(element => {
              if (val.includes("_") && element.val === val.split("_")[0]){
                element.val = val.split("_")[0]
                element.option = val.split("_")[1]
                container.push(element)
              }
              else if (!val.includes("_") && element.val === val) {
                container.push(element)
              }
            })
          } else if (prop === "insideDia"){
            rawData.value[7]["step"+(7+1)].forEach(element => {
              if (element.val === val) {
                container.push(element)
              }
            })
          } else if (prop === "ringText"){
            const dt = "data="+val
            const value = qs.parse(dt)
            rawData.value[8]["step"+(8+1)].forEach(element => {
              if (value.data.includes("_") && element.val === value.data){
                element.val = value.data.split("_")[0]
                element.option = value.data.split("_")[1]
                container.push(element)
              }
              else if (value.data.includes("_") && element.val === value.data.split("_")[0]) {
                element.option = value.data.split("_")[1]
                container.push(element)
              }else if (!value.data.includes("_") && value.data === element.val){
                  container.push(element)
                // console.log('value: ',value.data)
                // console.log('ele val: ',element.val)
                // console.log('ele option: ',element.option)
              }
            })
          }
          else if (prop === "ringSize"){
            let valName = ""
            if(val == "00") {
              valName = "不明（12.5号以下）"
            }else if(val == "99") {
              valName = "不明（13号以上）"
            }else{
              valName = val
            }
            const data = {
              id:10000,
              step: 10,
              stepJp: "指輪のサイズ",
              name: "#"+valName,
              property: "ringSize",
              val: val,
              summary:"",
            }
            container.push(data)
          }
        }
      })
      store.commit("setResults", container)
    }
  }

  extractQueryValues()
  return {}
}
